import { z } from 'zod';

/**
 * Het type organisatie (ORG-1, ORG-3; ADR-0086, ADR-0099).
 *
 * Een eigen bestand zonder andere imports dan zod: `auth/registration.ts` heeft het type nodig, en
 * `auth/index.ts` wordt door bijna elk contract geïmporteerd. Met een import van `access` of
 * `tenants/index` erin liep dat in een kring. Het profiel zelf staat in `org-type-profile.ts`.
 */

/**
 * Het type organisatie (ORG-1). Een startprofiel: welke modules standaard aan staan, hoe nieuwe
 * mensen zich aanmelden, hoe de systeemrollen heten, en (ORG-2) welke woorden de app gebruikt ("lid"
 * in een vereniging, "medewerker" in een fabriek).
 *
 * `sports_club` (ORG-3) is een vereniging die rond ploegen en wedstrijden draait: "de club", "de
 * trainer", "de ploeg". `association` blijft de algemene vereniging (een jeugdbeweging, een
 * vzw), waar "ploeg" geen vanzelfsprekend woord is.
 */
export const orgTypeSchema = z.enum([
  'factory',
  'government',
  'association',
  'sports_club',
  'school',
  'care',
  'office',
]);
export type OrgType = z.infer<typeof orgTypeSchema>;

/** Hoe nieuwe mensen zich standaard aanmelden: personeelsnummer met pincode, of e-mail. */
export const loginDefaultSchema = z.enum(['email', 'pin']);
export type LoginDefault = z.infer<typeof loginDefaultSchema>;
